import React, { useState, useContext, useEffect, Fragment } from 'react';
import YesNo from '../../../../../components/Dialog/YesNo';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from '../../../../../api/axios';
import { useParams } from 'react-router-dom';
import { store as mainStore } from '../../../../../store';
import { store } from './Tendering';
import Progressbar from '@material-ui/core/LinearProgress';
import moment from 'moment-jalaali';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  date: {
    width: '100%',
    textAlign: 'right',
  },
}));

const MarketingDialog = ({ open, onClose, drivers }) => {
  const classes = useStyles();
  const [text, setText] = useState('');
  const [marketings, setMarketings] = useState(null);
  const { id: orderId } = useParams();
  const { showMessage, showError } = useContext(mainStore);
  const { dispatch, asyncRefresh } = useContext(store);
  const [loading, setLoading] = useState(false);
  const [loadingMarketing, setLoadingMaketing] = useState(true);

  const handleChangeText = (e) => {
    let { value } = e.target;
    setText(value);
  };
  const handleClose = async (agree, desc = null) => {
    if (agree) {
      setLoading(true);
      try {
        const {
          data: { messages, order },
        } = await axios.post(`/api/v1/admin/orders/tendering/add/marketing`, {
          orderId,
          drivers,
          text: text || desc,
        });
        setLoading(false);
        showMessage(messages);
        dispatch({ type: 'ORDER', payload: order });
        onClose(true);
      } catch (error) {
        showError(error);
        setLoading(false);
      }
    } else {
      onClose(false);
      setLoading(false);
    }
  };
  const handleClick = async (description) => {
    setText(`${description}`);
    await handleClose(true, description);
  };

  useEffect(() => {
    setMarketings([]);
    if (!open) return;
    if (!drivers?.length || drivers?.length > 1) return;
    (async () => {
      setLoadingMaketing(true);
      const { data } = await axios.get(
        `api/v1/admin/orders/tendering/list/marketings/${orderId}/${drivers[0]}`
      );
      setMarketings(data.logs || []);
      setLoadingMaketing(false);
    })();
    return () => {
      setText('');
    };
  }, [open]);

  return (
    <YesNo
      loadingButton={true}
      inProgress={loading}
      yes="ثبت"
      no="صرفنظر"
      onClose={handleClose}
      open={open}
      title="ثبت بازاریابی جدید"
    >
      <div className={classes.root}>
        <Divider />
        {!loadingMarketing ? (
          <Fragment>
            {marketings.map((m) => (
              <Alert key={m._id} icon={false} severity="info" fullWidth>
                <AlertTitle>{m.log.text}</AlertTitle>
                بازاریابی توسط: {`${m.creator.firstName} ${m.creator.lastName}`}{' '}
                - تاریخ: {moment(m.createdAt).format('jYY/jMM/jDD')}
              </Alert>
            ))}
            <Divider />
          </Fragment>
        ) : (
          <Progressbar />
        )}
        <List>
          <ListItem
            button
            onClick={() => handleClick('عدم حضور در مبدا بارگیری')}
          >
            <ListItemText primary="عدم حضور در مبدا بارگیری" />
          </ListItem>
          <ListItem button onClick={() => handleClick('عدم تجهیزات کافی')}>
            <ListItemText primary="عدم تجهیزات کافی" />
          </ListItem>
          <ListItem button onClick={() => handleClick('عدم ظرفیت تناژ')}>
            <ListItemText primary="عدم ظرفیت تناژ" />
          </ListItem>
          <ListItem button onClick={() => handleClick('کرایه پایین')}>
            <ListItemText primary="کرایه پایین" />
          </ListItem>
          <ListItem button onClick={() => handleClick('عدم انتخاب نوع بار')}>
            <ListItemText primary="عدم انتخاب نوع بار" />
          </ListItem>
          <ListItem button onClick={() => handleClick('سایر')}>
            <ListItemText primary="سایر" />
          </ListItem>
        </List>
        <TextField
          fullWidth
          variant="outlined"
          label="شرح بازاریابی انجام شده"
          multiline
          rows={3}
          value={text}
          onChange={handleChangeText}
        />
      </div>
    </YesNo>
  );
};

export default React.memo(MarketingDialog);
